export var CONFIG = {};
export var firebase;
export var Bootstrap = function Bootstrap(config, _firebase) {
  CONFIG = config;
  firebase = _firebase;
  firebase.initializeApp(config.firebaseConfig);
};
export var setConfig = function setConfig(config) {
  CONFIG = config;
};